import { ReactNode } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import type { DialogProps } from "@mui/material";
import SubmitButton from "./Buttons/SubmitButton/SubmitButton";
import { COLORS } from "../../values/colors";

interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  description: ReactNode;
  confirmText: string;
  cancelText?: string;
  isConfirming?: boolean;
  maxWidth?: DialogProps["maxWidth"];
  onConfirm: () => void;
  onClose: () => void;
}

const ConfirmationDialog = ({
  open,
  title,
  description,
  confirmText,
  cancelText = "Abbrechen",
  isConfirming = false,
  maxWidth = "sm",
  onConfirm,
  onClose,
}: ConfirmationDialogProps) => {
  const handleClose = () => {
    if (isConfirming) {
      return;
    }

    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth={maxWidth}
      PaperProps={{
        sx: {
          borderRadius: "1.1rem",
          padding: "0.35rem",
          backgroundColor: COLORS.darkGray,
          color: COLORS.textPrimary,
          border: `1px solid ${COLORS.gray}`,
          boxShadow: "0 24px 60px rgba(0, 0, 0, 0.45)",
          backgroundImage: "none",
        },
      }}
    >
      <DialogTitle sx={{ pb: 0, fontSize: "1.35rem", fontWeight: 700, color: COLORS.textPrimary }}>{title}</DialogTitle>
      <DialogContent sx={{ pt: "1rem !important", color: COLORS.textSecondary }}>{description}</DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 0, gap: 1, justifyContent: "flex-end" }}>
        <Button
          type="button"
          variant="text"
          onClick={handleClose}
          disabled={isConfirming}
          sx={{ color: COLORS.textSecondary }}
        >
          {cancelText}
        </Button>
        <SubmitButton text={isConfirming ? `${confirmText}...` : confirmText} onClick={onConfirm} disabled={isConfirming} />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
